const styles = {
    buttons: {
        float: 'right'
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/common/SettingsPage/SettingsPage.css.js